"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YbxTurret = void 0;
var tslib_1 = require("tslib");
var yieldblox_base_1 = require("yieldblox-base");
var turrets_1 = require("./turrets");
var YbxError_1 = require("./YbxError");
var YbxTurret = (function () {
    function YbxTurret() {
        this._contractHash = "";
        this.Loaded = false;
        this._turrets = [];
        this.expiration = 0;
    }
    YbxTurret.prototype.Turrets = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.refresh()];
                    case 1:
                        _a.sent();
                        return [2, this._turrets];
                }
            });
        });
    };
    YbxTurret.prototype.runContract = function (event, authToken) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var turrets, resp;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.Turrets()];
                    case 1:
                        turrets = _a.sent();
                        return [4, turrets_1.ybxApi.RunContract(authToken, event, turrets, this._contractHash)];
                    case 2:
                        resp = _a.sent();
                        return [2, resp.signedXdr];
                }
            });
        });
    };
    YbxTurret.prototype.getFeeForTurret = function (turretId, authToken) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var turret, fee, feeValue;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.refresh();
                        turret = this._turrets.find(function (x) { return x.turretId == turretId; });
                        if (turret == undefined) {
                            throw new Error("turret not found : ".concat(turretId));
                        }
                        return [4, turrets_1.ybxApi.GetTurretFeeBalances(turret, authToken)];
                    case 1:
                        fee = _a.sent();
                        feeValue = parseFloat(fee.balance);
                        if (isNaN(feeValue)) {
                            throw new YbxError_1.YbxError("fee value invalid ".concat(feeValue, " for turret ").concat(turretId));
                        }
                        return [2, feeValue];
                }
            });
        });
    };
    YbxTurret.prototype.sendFeesToTurret = function (turretId, authToken, paymentXdr) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var turret, fee, feeValue;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.refresh();
                        turret = this._turrets.find(function (x) { return x.turretId == turretId; });
                        if (turret == undefined) {
                            throw new Error("turret not found : ".concat(turretId));
                        }
                        return [4, turrets_1.ybxApi.SendFeesToTurret(turret, authToken, paymentXdr)];
                    case 1:
                        fee = _a.sent();
                        feeValue = parseFloat(fee.balance);
                        if (isNaN(feeValue)) {
                            throw new YbxError_1.YbxError("fee value invalid ".concat(feeValue, " for turret ").concat(turretId));
                        }
                        return [2, feeValue];
                }
            });
        });
    };
    YbxTurret.prototype.refresh = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var ybxBase, governance, _a;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(Date.now() > this.expiration || this._turrets.length == 0)) return [3, 3];
                        ybxBase = new yieldblox_base_1.YbxBase();
                        return [4, ybxBase.governance()];
                    case 1:
                        governance = _b.sent();
                        this._contractHash = governance.data.getContractHash();
                        _a = this;
                        return [4, turrets_1.TurretHelper.GetTurrets(governance)];
                    case 2:
                        _a._turrets = _b.sent();
                        this.expiration = Date.now() + 60 * 60 * 1000;
                        this.Loaded = true;
                        _b.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    return YbxTurret;
}());
exports.YbxTurret = YbxTurret;
//# sourceMappingURL=YbxTurret.js.map